"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hook_1 = require("./hook");

function Effect(_a) {
  var kind = _a.kind,
      perform = _a.perform;
  hook_1.useServerEffect(perform, kind);
  return null;
}

exports.Effect = Effect;